export default __webpack_public_path__ + "locales/fi/MainBar.json?hash=6223baa6c1cfbfedfe6d8871786a5ef0";